import { AfterViewInit, Component, Input, OnDestroy } from "@angular/core";
import { Chart } from "angular-highcharts";
import { Title } from "@angular/platform-browser";
import { Subscription } from "rxjs/Subscription";
import { TransactionService } from "../../../services/transaction.service";

@Component({
  selector: "app-transactions-type",
  templateUrl: "./transactions-type.component.html",
  styleUrls: ["./transactions-type.component.scss"],
})
export class TransactionsTypeComponent implements AfterViewInit, OnDestroy {
  @Input() preloadData: any = null;
  @Input() chartOnly = false;
  @Input() height = "500";
  @Input() title = "";

  private preloadSubscription: Subscription;

  chart: Chart;
  private appTitle: Title;

  constructor(private transactionService: TransactionService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (!this.chartOnly) {
      this.appTitle.setTitle("EDI - Transactions By Type");
    }
    if (this.preloadData === null) {
      this.preloadSubscription = this.transactionService
        .preloadData()
        .subscribe(
          (res) => {
            this.handlePreloadData(res);
          },
          () => {
            // failed to load data
          }
        );
    } else {
      this.handlePreloadData(this.preloadData);
    }
  }

  ngOnDestroy() {
    if (this.preloadSubscription) {
      this.preloadSubscription.unsubscribe();
    }
  }

  handlePreloadData(res) {
    const me = this;
    this.chart = new Chart({
      chart: {
        type: "pie",
      },
      xAxis: {
        title: {
          text: "Timeline",
        },
        type: "datetime",
      },
      yAxis: {
        min: 0,
        title: {
          text: "Number of transactions",
        },
      },
      title: {
        text: this.title,
        y: 20,
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            padding: 1,
          },
        },
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      tooltip: {
        pointFormat: "Value: {point.y:,.0f}",
      },
    });
    this.onSubmit();
  }

  onSubmit() {
    this.loadChartData();
  }

  loadChartData(params: any = null) {
    const me = this;
    let series = [];
    this.preloadData.transactions.forEach(function (item) {
      let obj = {
        name: item.ED1_TYPE,
        y: parseFloat(item.TOTAL),
      };

      series.push(obj);
    });

    me.chart.addSerie({
      data: series,
      dataLabels: {
        padding: 5,
      },
    });
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transactions/transactions-type/transactions-type.component.ts